// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"23":"examples","88":"browse","177":"home","218":"mapping","443":"about"}[chunkId] + ".css";
};